module.exports = __webpack_public_path__ + "img/tablista_congelado.f99263b2.png";